<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-7 col-centered">
                    <EnterpriseAlert></EnterpriseAlert>
                </div>
                <div class="col-md-7 col-centered">
                    <BeneficiaryNotCoveredAlert></BeneficiaryNotCoveredAlert>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import EnterpriseAlert from './EnterpriseAlert';
import BeneficiaryNotCoveredAlert from './BeneficiaryNotCoveredAlert';

export default {
    components: {
        EnterpriseAlert,
        BeneficiaryNotCoveredAlert
    }
}
</script>